<template>
  <div class="portal">
    <h2 class="mb-3">خلاصه عملکرد</h2>
    <v-card class="text-center pa-4">
      <v-card-title>گزارش کلی</v-card-title>
      <div v-if="!loading" class="pa-3">
        عمکرد پورتال {{ portal.name }} به صورت خلاصه به شرح زیر می باشد:
        <v-simple-table dense class="pt-3">
          <template v-slot:default>
            <tbody>
              <tr>
                <td>میزان فروش</td>
                <td>
                  <number
                    :number="sumOfPayments ? sumOfPayments[0].total : 0"
                    unit="تومان"
                  ></number>
                </td>
              </tr>
              <tr>
                <td>سهم پورتال</td>
                <td>
                  <span v-if="sumOfPayments"> ({{ portal.percentage }}%) </span>
                  <number
                    :number="sumOfPayments ? sumOfPayments[0].share : 0"
                    unit="تومان"
                  ></number>
                </td>
              </tr>
              <tr>
                <td>تعداد فروش</td>
                <td>
                  <number
                    :number="sumOfPayments ? sumOfPayments[0].count : 0"
                    unit="عدد"
                  ></number>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
    <div class="text-center mt-5">
      <v-btn depressed router :to="{ name: 'Portals' }"> بازگشت </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "summery-portal-component",
  data() {
    return {
      loading: true,
      portal: null,
      sumOfPayments: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const apiUrl = "payments/portal/sum/admin/" + this.$route.params.id;
      this.$api.get(apiUrl).then((res) => {
        this.portal = res.data.portal;
        if (res.data.sumOfPayments.length > 0) {
          this.sumOfPayments = res.data.sumOfPayments;
        }
        this.loading = false;
      });
    }
  }
};
</script>
